export const urls = {
  CLIENT_URL: "https://kuts-in.web.app",
  SERVER_URL: "https://link-shortener-backend-epgb.onrender.com",
};

// These should be consistent as the same name is going to be used in backend.
export const languages = [
  "Auto",
  "Amharic",
  "Arabic",
  "Basque",
  "Bengali",
  "Bulgarian",
  "Catalan",
  "Cherokee",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "English",
  "Estonian",
  "Filipino",
  "Finnish",
  "French",
  "German",
  "Greek",
  "Gujarati",
  "Hebrew",
  "Hindi",
  "Hungarian",
  "Icelandic",
  "Indonesian",
  "Italian",
  "Japanese",
  "Kannada",
  "Korean",
  "Latvian",
  "Lithuanian",
  "Malay",
  "Malayalam",
  "Marathi",
  "Norwegian",
  "Polish",
  "Portuguese",
  "Romanian",
  "Russian",
  "Serbian",
  "Chinese (zh-CN)",
  "Slovak",
  "Slovenian",
  "Spanish",
  "Swahili",
  "Swedish",
  "Tamil",
  "Telugu",
  "Thai",
  "Chinese (zh-TW)",
  "Turkish",
  "Urdu",
  "Ukrainian",
  "Vietnamese",
  "Welsh",
];
